export default [  
  {
    path: '/engagements',
    name: 'engagements',
    component: () => import('@/views/modules/engagements/list'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      title:'Engagements List',
      breadcrumb: [
        { text: 'Home',  to: { name: "home" } },
        { text: 'Engagements' }
      ]
    },
    children:[
      {
        path: '/engagements/create',
        name: 'engagements-create',
        component: () => import('@/views/modules/engagements/create'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Engagement Create',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Engagements', link: '/engagements' },
            { text: 'Create' }
          ]
        }
      },
      {
        path: '/engagements/:id/edit',
        props: true,
        name: 'engagements-edit',
        component: () => import('@/views/modules/engagements/edit'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Engagements Edit',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Engagement',  to: { name: "engagements-show" }, param: 'id' },
            { text: 'Edit' }
          ]
        }
      },
      {
        path: '/engagements/:id/show',
        props: true,
        name: 'engagements-show',
        component: () => import('@/views/modules/engagements/show'),
        meta: {
          sidebarToggle: true,
          requiresAuth: true,
          layout: 'app',
          title:'Engagements Details',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Engagements',  to: { name: "engagements" } },
            { text: 'Details' }
          ]
        }
      },
    
    ]
  },

 
]